export default "__VITE_ASSET__DsQeQWIT__"